import { render, staticRenderFns } from "./DesktopSidebar.vue?vue&type=template&id=6b6b8cf0&"
import script from "./DesktopSidebar.vue?vue&type=script&lang=js&"
export * from "./DesktopSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DashboardFilter: require('/home/examenbankv1/examenservices-schoolexamenbank-nuxt/nuxt/components/dashboard/Filter.vue').default})
